module.exports = __webpack_public_path__ + "c08bbc0b7dc50bb176267615b11e1a6b.pdf";